











import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import emitter from "@/lib/emitter";
import { formatDate, parseISO } from "@/lib/time";
import { EVENTS } from "@/const";
import BaseChip from "@/components/BaseChip";
import OptionItem from "../OptionItem";

@Component({ name: "OptionSchedulePost", components: { OptionItem, BaseChip } })
export default class OptionSchedulePost extends Vue {
  @Prop({ required: true })
  public readonly postData!: ContentSet;

  public get show() {
    return !this.postData.publishTime;
  }

  public get scheduleTime() {
    const time = this.postData.scheduleTime;
    if (!time) return null;
    const date = parseISO(time);
    if (date.getTime() <= new Date().getTime()) return null;
    return formatDate(new Date(date), {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  public onClick() {
    emitter.emit(EVENTS.CONTENT_FEED_SCHEDULE_POST_SHOW);
  }
}
